var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-details',{attrs:{"id":_vm.orgId,"display-users-list":false,"seat-edit-mode":"REQUEST"}})}
var staticRenderFns = []

export { render, staticRenderFns }